// extracted by mini-css-extract-plugin
module.exports = {"ZCComp":"ZC_ZCComp__RO7L7"};